// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'row-delete';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M17.001 1.03H1m16.001 16H1m8.001-6.4v6.4m0-16v6.4m2.667 5.867L9.001 10.63l-2.666 2.667m5.333-8.533L9.001 7.43 6.335 4.764'
  />
);

export const viewBox = '0 0 18 18';
